import '../components/css components/logistics.css';
import hrcover from "../images/cover-all.jpg";
import circle from "../images/hr-modified.png";

function Hr(){
    return(
        <div className='logistics' id='logistics'>
                        <div className='stick-them'>
                            <img src={hrcover} alt='logistics' className='cover-all'/>
                            <img src={circle} alt='logistics' className='circle-c' />
                        </div>
                    <h2>HR Circle</h2>
                    <p className='quote'>"Where the journey of talent begins and success stories unfold."</p>
                    <p className='paragraph'>Human Resources Circle is the first follower and represents the spirit of all team members. The tasks of the Circle are as follows:
                    <ul>
                        <li>Raising team spirit and maintaining balance among members.</li>
                        <li>Participating in setting and coordinating the Circle's regulations and identifying the team's need for new members.</li>
                        <li>Conducting personal interviews and evaluating members.</li>
                        <li>Implementing specific penalties.</li>
                        <li>Identifying and deciding the dismissal of a member in coordination with both the Circle official and the team leader.</li>
                        <li>Creating weekly and monthly reports on the Circle's activities and documenting everything accomplished throughout the year.</li>
                        <li>Collaborating with those responsible for setting the meeting plan and following up on the required tasks.</li>
                    </ul>

They are also responsible for communicating with members before meetings, evaluating weaknesses, and actively working to address them. Additionally, they are responsible for establishing the Key Performance Indicators (KPIs) suitable for each Circle.</p>
        </div>
    );
}

export default Hr;